const btnConfs = {
	选择: { icon: 'bullseye' }, //正常图标样式
	预览: { icon: 'file-pdf-o' },
	文档: { icon: 'file-word-o' },
	切换: { icon: 'window-restore' },
	审核: { icon: 'check-square-o' },
	刷新: { icon: 'refresh' },
	翻译: { icon: 'globe' },
	链接: { icon: 'link' },
	查看: { icon: 'eye' },
	发送: { icon: 'send-o' },
	详情: { icon: 'info' },
	全选: { icon: 'check' },
	全不选: { icon: 'close' },
	活动: { icon: 'check-circle', ui: 'action' },
	不活动: { icon: 'minus-circle', ui: 'action decline alt' },
	启用: { icon: 'toggle-on' },
	停用: { icon: 'toggle-off', ui: 'action decline alt' },
	报废: { icon: 'power-off', ui: 'action decline alt' },
	开始: { icon: 'play' },
	暂停合同: { icon: 'pause', ui: 'action decline alt' },
	中止合同: { icon: 'stop', ui: 'action decline alt' },
	增员: { icon: 'user-plus' },
	目录: { icon: 'folder-o' },

	无: { icon: '', ui: '' }, //无图标、无样式
	删_除: { icon: 'trash-o', ui: 'decline' }, //无action
	取_消: { icon: 'ban', ui: 'decline' },
	确_定: { icon: 'check', ui: '' },
	添_加: { icon: 'plus', ui: '' },
	编_辑: { icon: 'edit', ui: '' },
	提_交: { icon: 'share', ui: '' },
	查_看: { icon: 'eye', ui: '' },
	查_询: { icon: 'search', ui: '' },
	复_制: { icon: 'files-o', ui: '' },
	详_情: { icon: 'file-text-o', ui: '' },
	预_览: { icon: 'file-pdf-o', ui: '' },
	计_算: { icon: 'calculator', ui: '' },
	选_择: { icon: 'bullseye', ui: '' },
	链_接: { icon: 'link', ui: '' },
	展_开: { icon: 'plus', ui: '' },
	收_缩: { icon: 'minus', ui: '' },
	右_移: { icon: 'arrow-circle-right', ui: '' },

	链_接1: { icon: 'link', ui: 'decline' }, //1 表示decline，红色预警

	查_看2: { icon: 'eye', ui: 'action' },  //2 表示_tool控件应用,需要action
	编_辑2: { icon: 'edit', ui: 'action' },
	审_核2: { icon: 'check-square-o', ui: 'action' },
}

export default btnConfs